import React from "react";
import Blog_50_2 from "../component/Blog_50_2";
function Blog_50_2_container() {
  return <Blog_50_2 />;
}

export default Blog_50_2_container;
